import HttpResponse from 'es/core/net/HttpResponse';

/**
 * Passes the response through to the caller as-is, without taking any action based on the response status.
 */
const passThroughResponseInterceptor = (response: HttpResponse) => response;

export default passThroughResponseInterceptor;